import React, { Component } from 'react';
import { Detector } from 'react-detect-offline';
import offlineImage from 'static/img/network-error.svg';
import { OfflineToast, OnlineToast } from './toast';

const polling = { enabled: false };

class DetectNetwork extends Component {
  handleNetworkChange = isOnline => {
    if (isOnline) {
      OnlineToast();
    } else {
      OfflineToast();
    }
  };

  render() {
    const { children } = this.props;

    return (
      <>
        {/* To load offline image */}
        <img
          src={offlineImage}
          style={{ display: 'none' }}
          alt="offline-image"
        />

        <Detector
          onChange={this.handleNetworkChange}
          render={({ online }) => {
            return children;
          }}
          polling={polling}
        />
      </>
    );
  }
}
export default DetectNetwork;
